'use client';

import React, { useState, useRef } from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import PlayVideoButton from '../buttons/play_video_button';
import useHideOnSite from '../../hooks/useLanguageFilter';

const Video = ({ blok }) => {
  // ID for external (Youtube) URL:s

  const videoId = blok.video.is_external_url
    ? blok.video.filename.split('/').pop()
    : 'dQw4w9WgXcQ';

  const videoRef = useRef(null);
  const [toggleVideoControls, settoggleVideoControls] = useState(false);
  const toggleVideo = () => {
    if (videoRef.current.paused) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
  };

  // TailwindCSS utility classes --- --- --- --- --->
  const widths = {
    'w-1/4': 'col-span-12 sm:col-span-6 md:col-span-3',
    'w-1/3': 'col-span-12 sm:col-span-6 md:col-span-4',
    'w-1/2': 'col-span-12 sm:col-span-6',
    'w-2/3': 'col-span-12 sm:col-span-8',
    'w-3/4': 'col-span-12 sm:col-span-9',
    'w-full': 'col-span-12 w-full',
  };

  // >--- --- --- --- --- TailwindCSS utility classes

  // Iframe used for external (Youtube) URL, video tag for videos from media library.
  return useHideOnSite(blok.hide_on_site) ? null : blok.video
      .is_external_url ? (
    <div
      className={`flex flex-shrink-0 aspect-video ${
        widths[blok.width]
      } p-2 sm:p-4`}
      {...storyblokEditable(blok)}
    >
      <iframe
        className="h-full w-full object-cover"
        id={blok._uid}
        title={blok.video.name}
        type="text/html"
        width="100%"
        height="auto"
        src={`https://www.youtube.com/embed/${videoId}?iv_load_policy=3&rel=0`}
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope;"
        allowFullScreen
      ></iframe>
    </div>
  ) : (
    <div
      className={`flex flex-shrink-0 ${widths[blok.width]} relative p-2 sm:p-4`}
      {...storyblokEditable(blok)}
    >
      <video
        ref={videoRef}
        poster={blok.video_poster}
        className="h-full w-full object-cover"
        autoPlay={false}
        loop={false}
        playsInline
        controls={toggleVideoControls}
        controlsList="nodownload noremoteplayback nooverlay"
      >
        <source src={`${blok.video.filename}`} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
        <PlayVideoButton
          size="35%"
          onClick={() => {
            settoggleVideoControls(!toggleVideoControls);
            toggleVideo();
          }}
        />
      </div>
    </div>
  );
};

export default Video;
